import { FormBuilder, Validators } from '@angular/forms';
import { Examen } from '../Examen.config';
import { apellidoNombreTrabajadorValidator } from '../../../../../utils/apellido-nombre-trabajador-validator';

export class EstudioHistoriaClinica extends Examen {
  id = 9;
  code = 'HC';
  name = 'HISTORIA CLÍNICA';
  baseUrl = 'estudios/carga';
  isAttachedFileRequire = false;
  sections = [
    {
      name: 'HISTORIA CLÍNICA',
      fields: {
        fechaRealizacion: [ '', [ Validators.required ] ],
      },
    },
    {
      name: 'Empleador',
      fields: {
        responsableMedico: [false, [Validators.required]],
      },
      numberForm: 1,
    },
    {
      name: 'Trabajador',
      fields: {
        apellidoNombre:['', [Validators.required, Validators.maxLength(100), apellidoNombreTrabajadorValidator]],
        fechaNacimiento: ['', [Validators.required]],
        calle: ['', [Validators.required, Validators.maxLength(100)]],
        numeroCalle: ['', [Validators.required, Validators.maxLength(100)]],
        piso: ['', [Validators.maxLength(15)]],
        departamento: ['', [Validators.maxLength(15)]],
        localidad: ['', [Validators.required, Validators.maxLength(100)]],
        codigoPostal: ['', [Validators.required, Validators.maxLength(15), Validators.pattern(/^\S*$/)]],
        codigoPostalArgentino: ['', [Validators.required, Validators.maxLength(10), Validators.pattern(/^\S*$/)]],
        telefono: ['', [Validators.maxLength(80)]],
        sector: ['', [Validators.required, Validators.maxLength(15)]],
        edad: ['', [Validators.required]],
        puestoTrabajador: ['', [Validators.required]],
        fechaIngresoEmpresa: ['', [Validators.required]],
        antiguedadPuestoTrabajador: ['', [Validators.required]],
        realizacionExamenPreocupacional: [false, [Validators.required]],
        examenPreocupacionalObservacion: [{ value: '', disabled: true }],
      },
      numberForm: 2,
    },
    {
      name: 'Datos clínicos',
      fields: {
        sintomasActividadLaboral: [false, [Validators.required]],
        descripcionSintomasActividadLaboral: [{ value: '', disabled: true }],
        antecedentesPersonalesEnfermedades: [false, [Validators.required]],
        observacionesAntecedentesPersonales: [{ value: '', disabled: true }],
        realizaTratamiento: [{ value: false, disabled: true }],
        descripcionTratamiento: [{ value: '', disabled: true }],
        tomaMedicamentos: [{ value: null, disabled: true }],
        detalleTomaMedicamentos: [{ value: '', disabled: true }],
        peso: [null, [Validators.required, Validators.min(40), Validators.max(180)]],
        talla: [null, [Validators.required, Validators.min(100), Validators.max(220)]],
        indiceMasaCorporal: [null, Validators.required],
        frecuenciaPulso: [null, [Validators.required, Validators.min(35), Validators.max(220)]],
        presionSistolica: [null, [Validators.required, Validators.min(50), Validators.max(300)]],
        presionDiastolica: [null, [Validators.required, Validators.min(50), Validators.max(150)]],
        noFumador: [true],
        fumador: [false],
        exFumador: [false],
        fumaUnoDiez: [{ value: false, disabled: true }],
        fumaOnceVeinte: [{ value: false, disabled: true }],
        fumaMasVeinte: [{ value: false, disabled: true }],
        cantidadFuma: [{ value: null, disabled: true }],
        unidadTiempo: [{ value: '', disabled: true }],
        consumeAlcohol: [false],
        cantidadAlcohol: [{ value: '', disabled: true }],
        tipoAlcohol: [{ value: '', disabled: true }],

      },
      numberForm: 3,
    },
    {
      name: 'Estudio',
      fields: {},
      numberForm: 4,
    },
    {
      name: 'Piel',
      fields: {
        pielAlteraciones: [false, [Validators.required]],
        prurito: [{ value: false, disabled: true }],
        vesiculas: [{ value: false, disabled: true }],
        eritema: [{ value: false, disabled: true }],
        ulceracion: [{ value: false, disabled: true }],
        botonAceite: [{ value: false, disabled: true }],
        hiperpigmentacion: [{ value: false, disabled: true }],
        fisuras: [{ value: false, disabled: true }],
        petequias: [{ value: false, disabled: true }],
        eczema: [{ value: false, disabled: true }],
        hipopigmentacion: [{ value: false, disabled: true }],
        hiperqueratosis: [{ value: false, disabled: true }],
        onicomicosis: [{ value: false, disabled: true }],
        otrosPielAlteraciones: [{ value: false, disabled: true }],
        //pielDescripcion: [{ value: '', disabled: true }],
        //pielLocalizacion: [{ value: null, disabled: true }],
        observacionesPiel: ['',[Validators.maxLength(1000)]],
      },
    },
    {
      name: 'Ojos',
      fields: {
        ojosAlteraciones: [false, [Validators.required]],
        irritacionConjuntival: [{ value: false, disabled: true }],
        cicatricesCornea: [{ value: false, disabled: true }],
        nistagmus: [{ value: false, disabled: true }],
        visionMonocular: [{ value: false, disabled: true }],
        cataratas: [{ value: false, disabled: true }],
        otrosOjos: [{ value: false, disabled: true }],
        alteracionVisionColores: [{ value: false, disabled: true }],
        descripcionOjos: [{ value: '', disabled: true }],
        ojoIzquierdoSinCorreccion: [ null, [Validators.required, Validators.min( 0 ), Validators.max( 10 ) ] ],
        ojoIzquierdoConCorreccion: [ null, [Validators.required, Validators.min( 0 ), Validators.max( 10 ) ] ],
        ojoDerechoSinCorreccion: [ null, [Validators.required, Validators.min( 0 ), Validators.max( 10 ) ] ],
        ojoDerechoConCorreccion: [ null, [Validators.required, Validators.min( 0 ), Validators.max( 10 ) ] ],
        observacionOjos: ['',[Validators.maxLength(1000)]],
      },
    },
    {
      name: 'Cavidad Oral',
      fields: {
        cavidadOralAlteraciones: [false, [Validators.required]],
        sangradoEncias: [{ value: false, disabled: true }],
        ribeteGengival: [{ value: false, disabled: true }],
        cariesMultiples: [{ value: false, disabled: true }],
        faltaPiezaDental: [{ value: false, disabled: true }],
        alteracionEsmalteDentario: [{ value: false, disabled: true }],
        otrosCavidadOral: [{ value: false, disabled: true }],
        descripcionCavidadOral: [{ value: '', disabled: true }],
        observacionesCavidadOral: ['',[Validators.maxLength(1000)]],
      },
    },
    {
      name: 'Nariz',
      fields: {
        narizAlteraciones: [false, [Validators.required]],
        observacionesNariz: [{ value: '', disabled: true }],
        rinoscopiaAlteraciones: [false, [Validators.required]],
        mucosaNasalPalida: [{ value: false, disabled: true }],
        mucosaNasalUlcerada: [{ value: false, disabled: true }],
        perforacionTabiqueNasal: [{ value: false, disabled: true }],
        narizInflamada: [{ value: false, disabled: true }],
        observacionesRinoscopia: ['',[Validators.maxLength(1000)]],
      },
    },
    {
      name: 'Cuello',
      fields: {
        cuelloAlteraciones: [false, [Validators.required]],
        observacionesCuelloAlteraciones: [{ value: '', disabled: true }],
        observacionesCuello: ['',[Validators.maxLength(1000)]],
      },
    },
    {
      name: 'Tórax',
      fields: {
        toraxAlteraciones: [false, [Validators.required]],
        crepitantes: [{ value: false, disabled: true }],
        subCrepitantes: [{ value: false, disabled: true }],
        roncus: [{ value: false, disabled: true }],
        disnea: [{ value: false, disabled: true }],
        sibilancias: [{ value: false, disabled: true }],
        deformacionesTorax: [{ value: false, disabled: true }],
        frecuenciaRespiratoria: [null, [Validators.required, Validators.min( 0 ), Validators.max( 200 )]],
        observacionesTorax: ['',[Validators.maxLength(1000)]],
      },
    },
    {
      name: 'Cardiocirculatorio',
      fields: {
        cardiocirculatorioAlteraciones: [false, [Validators.required]],
        arritmia: [{ value: false, disabled: true }],
        soplos: [{ value: false, disabled: true }],
        varices: [{ value: false, disabled: true }],
        c0mizq: [{ value: false, disabled: true }],
        c0mder: [{ value: false, disabled: true }],
        c0bilateral: [{ value: false, disabled: true }],
        c0asintomatico: [{ value: false, disabled: true }],
        c0sintomatico: [{ value: false, disabled: true }],
        c1mizq: [{ value: false, disabled: true }],
        c1mder: [{ value: false, disabled: true }],
        c1bilateral: [{ value: false, disabled: true }],
        c1asintomatico: [{ value: false, disabled: true }],
        c1sintomatico: [{ value: false, disabled: true }],
        c2mizq: [{ value: false, disabled: true }],
        c2mder: [{ value: false, disabled: true }],
        c2bilateral: [{ value: false, disabled: true }],
        c2asintomatico: [{ value: false, disabled: true }],
        c2sintomatico: [{ value: false, disabled: true }],
        c3mizq: [{ value: false, disabled: true }],
        c3mder: [{ value: false, disabled: true }],
        c3bilateral: [{ value: false, disabled: true }],
        c3asintomatico: [{ value: false, disabled: true }],
        c3sintomatico: [{ value: false, disabled: true }],
        c4amizq: [{ value: false, disabled: true }],
        c4amder: [{ value: false, disabled: true }],
        c4abilateral: [{ value: false, disabled: true }],
        c4aasintomatico: [{ value: false, disabled: true }],
        c4asintomatico: [{ value: false, disabled: true }],
        c4bmizq: [{ value: false, disabled: true }],
        c4bmder: [{ value: false, disabled: true }],
        c4bbilateral: [{ value: false, disabled: true }],
        c4basintomatico: [{ value: false, disabled: true }],
        c4bsintomatico: [{ value: false, disabled: true }],
        c5mizq: [{ value: false, disabled: true }],
        c5mder: [{ value: false, disabled: true }],
        c5bilateral: [{ value: false, disabled: true }],
        c5asintomatico: [{ value: false, disabled: true }],
        c5sintomatico: [{ value: false, disabled: true }],
        c6mizq: [{ value: false, disabled: true }],
        c6mder: [{ value: false, disabled: true }],
        c6bilateral: [{ value: false, disabled: true }],
        c6asintomatico: [{ value: false, disabled: true }],
        c6sintomatico: [{ value: false, disabled: true }],
        hemorroides: [{ value: null, disabled: true }],
        realizaTratHemorroides: [{ value: null, disabled: true }],
        descripcionRealizaTratHemorroides: [{ value: '', disabled: true }],
        observacionesCardiocirculatorio: ['',[Validators.maxLength(1000)]],
      },
    },
    {
      name: 'Abdomen',
      fields: {
        abdomenAlteraciones: [false, [Validators.required]],
        hepatomegalia: [{ value: false, disabled: true }],
        cicatricesQuirurgicas: [{ value: false, disabled: true }],
        esplenomegalia: [{ value: false, disabled: true }],
        hernia: [{ value: false, disabled: true }],
        otrasAbdomen: [{ value: false, disabled: true }],
        descripcionAbdomen: [{ value: '', disabled: true }],
        inguinalDirectaDerecha: [{ value: false, disabled: true }],
        inguinalDirectaIzquierda: [{ value: false, disabled: true }],
        inguinalDirectaBilateral: [{ value: false, disabled: true }],
        inguinalDirectaReductible: [{ value: false, disabled: true }],
        inguinalDirectaNoReductible: [{ value: false, disabled: true }],
        inguinalIndirectaDerecha: [{ value: false, disabled: true }],
        inguinalIndirectaIzquierda: [{ value: false, disabled: true }],
        inguinalIndirectaBilateral: [{ value: false, disabled: true }],
        inguinalIndirectaReductible: [{ value: false, disabled: true }],
        inguinalIndirectaNoReductible: [{ value: false, disabled: true }],
        inguinalMixtaDerecha: [{ value: false, disabled: true }],
        inguinalMixtaIzquierda: [{ value: false, disabled: true }],
        inguinalMixtaBilateral: [{ value: false, disabled: true }],
        inguinalMixtaReductible: [{ value: false, disabled: true }],
        inguinalMixtaNoReductible: [{ value: false, disabled: true }],
        curalDerecha: [{ value: false, disabled: true }],
        curalIzquierda: [{ value: false, disabled: true }],
        curalBilateral: [{ value: false, disabled: true }],
        curalReductible: [{ value: false, disabled: true }],
        curalNoReductible: [{ value: false, disabled: true }],
        umbilical: [{ value: null, disabled: true }],
        dolorMolestiaRegionInguinal: [{ value: null, disabled: true }],
        herniaIncipiente: [{ value: null, disabled: true }],
        anilloHerniarioComplaciente: [{ value: null, disabled: true }],
        observacionesAbdomen: ['',[Validators.maxLength(1000)]],
      },
    },
    {
      name: 'Columna Vertebral',
      fields: {
        columnaVertebralAlteraciones: [false, [Validators.required]],
        cicatricesQuirurgicasCc: [{ value: false, disabled: true }],
        cicatricesQuirurgicasCd: [{ value: false, disabled: true }],
        cicatricesQuirurgicasCls: [{ value: false, disabled: true }],
        contracturaMuscularCc: [{ value: false, disabled: true }],
        contracturaMuscularCd: [{ value: false, disabled: true }],
        contracturaMuscularCls: [{ value: false, disabled: true }],
        leseguePositivoDer: [{ value: false, disabled: true }],
        leseguePositivoIzq: [{ value: false, disabled: true }],
        puntosDolorososCc: [{ value: false, disabled: true }],
        puntosDolorososCd: [{ value: false, disabled: true }],
        puntosDolorososCls: [{ value: false, disabled: true }],
        deformidadCc: [{ value: false, disabled: true }],
        deformidadCd: [{ value: false, disabled: true }],
        deformidadCls: [{ value: false, disabled: true }],
        limitacionesMovilidadCc: [{ value: false, disabled: true }],
        limitacionesMovilidadCd: [{ value: false, disabled: true }],
        limitacionesMovilidadCls: [{ value: false, disabled: true }],
        observacionesColumnaVertebral: ['',[Validators.maxLength(1000)]],
      },
    },
    {
      name: 'Osteoarticular',
      fields: {
        osteoarticularAlteraciones: [false, [Validators.required]],
        miembroSuperiorDer: [{ value: false, disabled: true }],
        miembroSuperiorIzq: [{ value: false, disabled: true }],
        manoDer: [{ value: false, disabled: true }],
        manoIzq: [{ value: false, disabled: true }],
        dedosManoIzquierda: [{ value: false, disabled: true }],
        dedosManoDerecha: [{ value: false, disabled: true }],
        miembroInferiorDer: [{ value: false, disabled: true }],
        miembroInferiorIzq: [{ value: false, disabled: true }],
        rodillaDer: [{ value: false, disabled: true }],
        rodillaIzq: [{ value: false, disabled: true }],
        pieDer: [{ value: false, disabled: true }],
        pieIzq: [{ value: false, disabled: true }],
        observacionesOsteoarticular: ['',[Validators.maxLength(1000)]],
      },
    },
    {
      name: 'Neurologico',
      fields: {
        examenNeurologicoAlteraciones: [false, [Validators.required]],
        rombergAnormal: [{ value: false, disabled: true }],
        marcha: [{ value: false, disabled: true }],
        sensibilidad: [{ value: false, disabled: true }],
        coordinacion: [{ value: false, disabled: true }],
        temblor: [{ value: false, disabled: true }],
        pruebaDedoNariz: [{ value: false, disabled: true }],
        reflejos: [{ value: false, disabled: true }],
        alteracionImportanteSentidoOlfato: [{ value: false, disabled: true }],
        observacionesNeurologico: ['',[Validators.maxLength(1000)]],
      },
    },
    {
      name: 'Dictamen medico',
      fields: {
        medicoNombre: [ '', [ Validators.required, Validators.pattern( /^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]+$/ ), ] ],
        codigoDictamen: [ '', [ Validators.required ] ],
        matricula: ['', [Validators.required]],
        medicoEspecialidad: ['', [Validators.required]],
      },
      numberForm: 5,
    },
    {
      name: 'Adjuntos',
      fields: {},
      numberForm: 6,
    },
  ];

  constructor(formBuilder: FormBuilder) {
    super(formBuilder);
    this.fieldList = this.getFields();
    this.examForm = this.getForm();
    this.sectionsList = this.getSections();
  }
}
